import {ErrorType} from "~/enums/ErrorType";
import {Hash} from "~/interfaces/hashInterfaces";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";

export interface IErrorNavOpts {
  baseRoute?: string
  path?: string
  hash?: string
  query?: Hash<string>
  pageArea?: string
  elementClientId?: string
  targetElementId?: string
  containerElementSelector?: string
  beforeReveal?: (...args) => void
  reveal?: (targetElementId: string, containerElementSelector: string, fallbackContainerSelector: string) => Promise<JQuery>
  afterReveal?: (...args) => void
  useLocation?: false | string
  locationString: string
}

export interface IValidationError {
  message?: string;
  field?: string;
  displayName?: string;
  errorNavOpts?: Partial<IErrorNavOpts>;
  type?: ErrorType;
  section: ValidationModalSection | string;
  level: ValidationErrorLevel;
}

export default class ValidationError implements IValidationError {
  message?;
  displayName?;
  field?;
  errorNavOpts?;
  type: ErrorType.error;
  section;
  level: ValidationErrorLevel = ValidationErrorLevel.Error;

  constructor(options: Partial<IValidationError>) {
    Object.keys(options).forEach(k => {
      this[k] = options[k];
    });
  }
}

export enum ValidationErrorLevel {
  All = "ALL",
  Error = "ERROR",
  Warning = "WARNING",
}